// extracted by mini-css-extract-plugin
export default {"lubemathPageWrapper":"LubematchPage_lubemathPageWrapper__SgmBE","ol":"LubematchPage_ol__PahOr"};